import { HttpClient } from '../../httpClient'
import { throwIfNotAllowedContentType, validateHttpResponse } from '../../httpClient/utils'

export const promoteUser = async (client: HttpClient, userId: string, positionId: string) => {
	const response = await client.post(`/api/users/${userId}/promote`, { positionId })

	await validateHttpResponse(response)
	throwIfNotAllowedContentType(response, ['application/json'])

	return response.data
}
